import React from 'react'
import { Skeleton } from './Skeleton'

interface StatCardProps {
  icon: React.ReactNode
  label: string
  value: number | string | undefined
  color?: string
  isLoading?: boolean
  alert?: boolean
  alertColor?: string
}

export function StatCard({ icon, label, value, color = 'var(--text-primary)', isLoading, alert, alertColor }: StatCardProps) {
  const borderColor = alert && alertColor ? alertColor : 'var(--border-subtle)'
  const valueColor = alert && alertColor ? alertColor : color

  return (
    <div
      className="card-hover"
      style={{
        padding: '16px 20px',
        backgroundColor: 'var(--bg-secondary)',
        borderRadius: 'var(--radius-lg)',
        border: `1px solid ${borderColor}`,
        boxShadow: 'var(--shadow-card)',
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '12px',
      }}>
        <span style={{
          fontSize: '12px',
          fontWeight: 500,
          color: 'var(--text-secondary)',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          {label}
        </span>
        <span style={{ color: valueColor, opacity: 0.7 }}>{icon}</span>
      </div>
      {isLoading ? (
        <Skeleton width={60} height={32} />
      ) : (
        <div style={{
          fontSize: '32px',
          fontWeight: 500,
          color: valueColor,
          lineHeight: 1,
        }}>
          {value ?? 0}
        </div>
      )}
    </div>
  )
}
